"use client";
import { decodeHTML } from '@/services/helperFunctions';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChangeEvent, memo } from 'react';

type option = {
    name: string,
    value: string
}
interface SelectProps {
    label: string
    name: string,
    is_loading: boolean,
    handleInputChange: (e: ChangeEvent<HTMLSelectElement>) => void,
    optionsDataList: option[][],
    selectedOption: string,
    icon: IconProp,
    icon_color?: string,
    includeAlloption?: boolean
}
const DropdownSelect = ({ label, name, is_loading, handleInputChange, optionsDataList, selectedOption, icon, icon_color = '#294762', includeAlloption = false }: SelectProps) => {
        return (
            <div className={`col-lg-11 mx-auto mt-1 d-flex align-items-center justify-content-between border bg-white rounded did-floating-label-content p-1 ${is_loading && 'opacity-75 pe-none'}`}>
                <span className="input-group-prepend">
                    <div className="input-group-text border-gray border-0 border-end  bg-white px-1">
                        <label htmlFor={name}>
                            <FontAwesomeIcon color={icon_color} icon={icon} />
                        </label>
                    </div>
                </span>
                <select
                    id={name}
                    name={name}
                    className={`w-100 border-0 did-floating-select px-1 ${is_loading ? 'opacity-75 pe-none user-select-none':''}`}
                    aria-label={name}
                    aria-details={selectedOption}
                    onChange={(e) => handleInputChange(e)}
                    value={selectedOption}
                >
                    {includeAlloption && <option value="">-All-</option>}

                    {optionsDataList?.flatMap((optionsDataToMap, groupIndex) =>
                        optionsDataToMap
                            ? [
                                ...optionsDataToMap.map((optionsData, itemIndex) => (
                                    <option
                                        value={optionsData?.value}
                                        key={`${name}-${optionsData?.value || `item-${groupIndex}-${itemIndex}`}`}
                                    >
                                        {decodeHTML(optionsData?.name)}
                                    </option>
                                )),
                                groupIndex + 1 < optionsDataList.length && (
                                    <option key={`separator-${name}-${groupIndex}`} disabled>-------</option>
                                )
                            ]
                            : []
                    )}
                </select>

                <label className="did-floating-label">{label}</label>
            </div>
        )
}

export default memo(DropdownSelect)